export default __webpack_public_path__ + "static/media/13.eba1eac8.jpg";